import { SnackbarTypes } from './snackbar.reducer';
import { hideSnackbar } from '../Snackbar/snackbar.actions';
import { put } from 'redux-saga/effects';
import { showSnackbar } from './snackbar.actions';

export function* showSnackbarWithMessage(
  type: SnackbarTypes,
  message: string,
  hideAfter: number = 20000
) {
  yield put(
    showSnackbar({
      type,
      message,
    })
  );
  // delay() from react-redux stops complete process here..
  setTimeout(function*() {
    yield put(hideSnackbar());
  }, hideAfter);
}



// WEBPACK FOOTER //
// ./src/store/Snackbar/snackbar.saga.ts